import { useState, useEffect, useRef } from 'react';
import { Table } from 'antd';
// import InitPaginationML from '@/components/InitPaginationML';
import PaginationML from '@/components/PaginationML';
import Styled from './AntdTableStyles';
import { useMemo } from 'react';

/**
 * 监听页面可视区域高度变化的自定义Hook
 * @returns 当前可视区域的高度
 */

export const useViewportHeight = (domId) => {
  // 存储当前元素高度的状态
  const [elementHeight, setElementHeight] = useState(0);
  // 存储DOM元素的ref
  const targetRef = useRef();
  // 存储ResizeObserver实例的ref
  const resizeObserverRef = useRef();

  // 尝试获取DOM元素的函数
  const getTargetElement = () => {
    if (!domId) {
      return null;
    }
    return document.getElementById(domId);
  };

  // 初始化或更新元素引用
  useEffect(() => {
    targetRef.current = getTargetElement();
  }, [domId]); // 当domId变化时重新获取

  useEffect(() => {
    // 如果没有window对象或元素未找到，直接返回
    if (typeof window === 'undefined' || !targetRef.current) {
      return;
    }

    // 创建ResizeObserver实例
    resizeObserverRef.current = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setElementHeight(entry.target.clientHeight);
      }
    });

    // 监听目标元素
    resizeObserverRef.current.observe(targetRef.current);

    // 初始获取一次高度
    setElementHeight(targetRef.current.clientHeight);

    // 组件卸载时的清理函数
    return () => {
      if (resizeObserverRef.current && targetRef.current) {
        resizeObserverRef.current.unobserve(targetRef.current);
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }
    };
  }, [targetRef.current]); // 当目标元素变化时重新创建监听器

  return elementHeight;
};

const AntdTable = ({
  data,
  columns,
  pagination,
  showPageSize = true,
  page,
  total,
  changePage,
  // showPagingData,
  // showPageColor = false,
  id,
  // pages,
}) => {
  const tableHeight = useViewportHeight(id);
  const tabRowHeight = useMemo(() => {
    return tableHeight - 48 - 49 - 32 - 24;
  }, [tableHeight]);
  console.log('tabRowHeight', tabRowHeight);
  return (
    <Styled>
      <Table
        columns={columns}
        dataSource={data}
        pagination={pagination}
        // scroll={
        //   {
        //       y: tabRowHeight,
        //       x: 'max-content',
        //   }
        // }
      />
      {/* <InitPaginationML
        hasNext={hasNext}
        page={page}
        total={total}
        changePages={changePage}
        showPagingDataStatus={showPagingData?.status}
        showPageColor={showPageColor}
        pages={pages}
      /> */}
      <PaginationML
        page={page}
        total={total}
        showPageSize={showPageSize}
        changePages={changePage}
      />
    </Styled>
  );
};
export default AntdTable;
